import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  isActive?: boolean;
}

const PublicPageSettingIcon: React.FC<IconProps> = ({ isActive = false }) => {
  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.16667 5.74728V7.41394H1.66667V14.9139H13.3333V7.41394H10.8333V5.74728H13.3333C13.7754 5.74728 14.1993 5.92287 14.5118 6.23543C14.8244 6.54799 15 6.97192 15 7.41394V14.9139C15 15.356 14.8244 15.7799 14.5118 16.0925C14.1993 16.405 13.7754 16.5806 13.3333 16.5806H1.66667C1.22464 16.5806 0.800716 16.405 0.488155 16.0925C0.175595 15.7799 0 15.356 0 14.9139V7.41394C0 6.97192 0.175595 6.54799 0.488155 6.23543C0.800716 5.92287 1.22464 5.74728 1.66667 5.74728H4.16667ZM8.23667 0.304778L11.0358 3.10311C11.1922 3.25948 11.28 3.47156 11.28 3.69269C11.28 3.91383 11.1922 4.12591 11.0358 4.28228C10.8795 4.43864 10.6674 4.52649 10.4462 4.52649C10.2251 4.52649 10.013 4.43864 9.85667 4.28228L8.33333 2.75811V10.7473C8.33333 10.9683 8.24554 11.1803 8.08926 11.3365C7.93297 11.4928 7.72101 11.5806 7.5 11.5806C7.27899 11.5806 7.06702 11.4928 6.91074 11.3365C6.75446 11.1803 6.66667 10.9683 6.66667 10.7473V2.75811L5.14333 4.28228C5.06591 4.3597 4.97399 4.42112 4.87283 4.46302C4.77167 4.50492 4.66325 4.52649 4.55375 4.52649C4.44425 4.52649 4.33583 4.50492 4.23467 4.46302C4.13351 4.42112 4.04159 4.3597 3.96417 4.28228C3.88674 4.20485 3.82532 4.11294 3.78342 4.01177C3.74152 3.91061 3.71995 3.80219 3.71995 3.69269C3.71995 3.5832 3.74152 3.47477 3.78342 3.37361C3.82532 3.27245 3.88674 3.18054 3.96417 3.10311L6.76417 0.304778C6.95949 0.109623 7.22431 0 7.50042 0C7.77653 0 8.04134 0.109623 8.23667 0.304778Z"
        fill={isActive ? 'url(#paint0_linear_15400_3786)' : '#6E5E83'}
      />
      <defs>
        <linearGradient
          id="paint0_linear_15400_3786"
          x1="0"
          y1="8.29031"
          x2="14.8657"
          y2="6.87748"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FD84BE" />
          <stop offset="0.5" stopColor="#FB7BDB" />
          <stop offset="1" stopColor="#BF78F2" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PublicPageSettingIcon;
